/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CopyTextM from '../elements/CopyTextM';
import EventTeaserWrapper from '../events/EventTeaserWrapper';
import IconUser28 from '../../assets/icons/IconUser28';
import IconUser40 from '../../assets/icons/IconUser40';
import './profile-courses.scss';

class ProfileCourses extends Component {
  renderCourseList(title, courses) {
    const { onToggleAttend } = this.props;
    const attendingCourses = courses.filter((course) => course.isAttending);

    return (
      <div className="bt-profile-courses__section">
        <div className="bt-profile-courses__section-wrapper">
          <div className="bt-profile-courses__section-icon">{IconUser40}</div>
          <div className="bt-profile-courses__section-icon--mobile">{IconUser28}</div>
          <h3 className="bt-headline-three">{title}</h3>
        </div>
        {attendingCourses.length === 0 ? (
          <CopyTextM text="No courses available." />
        ) : (
          <ul className="bt-profile-courses__list">
            {attendingCourses.map((course) => (
              <EventTeaserWrapper key={course.id} event={course} onToggleAttend={onToggleAttend} forceMobile />
            ))}
          </ul>
        )}
      </div>
    );
  }

  render() {
    const { upcomingEventsSorted, pastEventsSorted } = this.props;

    return (
      <div className="bt-profile-courses">
        {this.renderCourseList('Registered Courses', upcomingEventsSorted)}
        {this.renderCourseList('Previously Attended Courses', pastEventsSorted)}
      </div>
    );
  }
}

ProfileCourses.propTypes = {
  upcomingEventsSorted: PropTypes.array.isRequired,
  pastEventsSorted: PropTypes.array.isRequired,
  onToggleAttend: PropTypes.func.isRequired,
};

ProfileCourses.defaultProps = {
  upcomingEventsSorted: [],
  pastEventsSorted: [],
  onToggleAttend: () => false,
};

export default ProfileCourses;
